import { useEffect } from 'react';
import type { RefObject } from 'react';
import { Tooltip } from 'bootstrap';

// Initialise Bootstrap's tooltip plugin for every [data-bs-toggle="tooltip"] element
// inside `ref`. The app doesn't load Bootstrap's JS globally, so pages that want real
// (styled) tooltips instead of the browser's native `title` bubble call this with a
// container ref plus the deps that change its contents — the tooltips are re-created
// (and the latest `title` re-read) whenever those change, and disposed on unmount.
export function useBootstrapTooltip(
  ref: RefObject<HTMLElement | null>,
  deps: unknown[] = [],
): void {
  useEffect(() => {
    const root = ref.current;
    if (!root) return;
    const instances = Array.from(
      root.querySelectorAll<HTMLElement>('[data-bs-toggle="tooltip"]'),
      (el) => new Tooltip(el),
    );
    return () => instances.forEach((t) => t.dispose());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
